import React, { 
    useEffect, 
    useRef, 
    useState 
} from 'react';
import './store-buttons.styles.scss';
import { 
    faCubesStacked, 
    faDice, 
    faGift, 
    faGlobeAmericas, 
    faPiggyBank, 
    faTicket 
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';


const StoreButtons = ({ 
    gameData, 
    availableItems, 
    setItemType, 
    itemType,
    isManager 
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ counts, setCounts ] = useState({})
    const [ initialTypeIsSet, setInitialTypeIsSet ] = useState(false);
    const [ itemTypeArr ] = useState([
        'inventory',
        'realworld',
        'collectible',
        'lottery',
        'prizepack',
        'contribution'
    ]);
    const textRef = useRef(null);

    useEffect(() => {
        if (!availableItems || initialTypeIsSet) return;
        
        for (let type of itemTypeArr) {
            let availItems = Object.values(availableItems)
            .filter(i =>
                i.type === 'item' &&
                i.opt_visible
            )
            const typeCount = availItems.filter(i => i.opt_itemType === type).length
            if (typeCount > 0) {
                setItemType(type);
                setInitialTypeIsSet(true);
                return;
            }
        }
    }, [availableItems, initialTypeIsSet])

    useEffect(() => {
        let countObj = {};
        itemTypeArr.forEach(type => {
            countObj[type] = 0;
        })
        if (availableItems) {
            itemTypeArr.forEach(type => {
                countObj[type] = Object.values(availableItems)
                .filter(i => i.opt_itemType === type).length;
            })
        };
        setCounts({...countObj});
    }, [availableItems])

    return (
        <div className={`store-buttons ${screenSize} ${isManager ? 'manager' : ''}`}>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "inventory" 
                        ? "primary"
                        : ""
                    }`
                }
                ref={textRef}
                onClick={() => setItemType("inventory")}
                title='Game Items' >
                <FontAwesomeIcon icon={faDice} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Inventory'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "realworld" 
                        ? "primary" 
                        : ""
                    }`
                }
                onClick={() => setItemType("realworld")}
                ref={textRef}
                title='Real Items'
            >
                <FontAwesomeIcon icon={faGlobeAmericas} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Real Items'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "collectible"
                        ? "primary"
                        : ""
                    } ${
                        (counts.collectible === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("collectible")}
                ref={textRef}
                title='Collectibles'
            >
                <FontAwesomeIcon icon={faCubesStacked} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Collectibles'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "lottery" 
                        ? "primary"
                        : ""
                    } ${
                        (counts.lottery === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("lottery")}
                ref={textRef}
                title='Lottery Tickets'
            >
                <FontAwesomeIcon icon={faTicket} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Lottery Tickets'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "prizepack" 
                        ? 'primary' 
                        : ''
                    } ${
                        (counts.prizepack === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("prizepack")}
                ref={textRef}
                title='Prize Packs'
            >
                <FontAwesomeIcon icon={faGift} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Prize Packs'
                    :
                    ''
                }
            </button>
            <button 
                className={
                    `g-button med-btn ${
                        itemType === "contribution" 
                        ? "primary"
                        : ""
                    } ${
                        (counts.contribution === 0) ? 'disabled' : ''
                    }`
                }
                onClick={() => setItemType("contribution")}
                ref={textRef}
                title='Contributions'
            >
                <FontAwesomeIcon icon={faPiggyBank} size="lg" />
                {
                    screenSize !== 'mobile'
                    ?
                    'Contributions'
                    :
                    ''
                }
            </button>
            
            {/* {
                (gameData.access.includes('tradePortal')) &&
                <button 
                    className={
                        `g-button med-btn ${
                            itemType === "tradeportal" 
                            ? 'primary' 
                            : ''
                        }`
                    }
                    onClick={() => setItemType("tradeportal")}
                    ref={textRef}
                    title='Trade Portal'
                >
                    <FontAwesomeIcon icon={faExchange} size={showText ? 'lg' : 'xl'} />
                    {
                        screenSize !== 'mobile'
                        ?
                        'Trade Portal'
                        :
                        ''
                    }
                </button>
            } */}
        </div>
    )
}

export default StoreButtons